import React from 'react'
import Header from '../../Components/Header'
import ContactSection from '../ContactUs/ContactSection'
import ContactFooter from '../ContactUs/ContactFooter'
import CallToAction from '../../LandingSection/CallToAction'
import Footer from '../../Components/Footer'
import WebDevelopmentServices from './WebDevelopmentServices'
import WhatWeOffer from './WhatWeOffer'
import RelatedCaseStudies from './RelatedCaseStudies'
import ProjectShowcase from '../../LandingSection/ProjectShowcase'



const Service = () => {
  return (
     <>
        <Header bgColor="#242424"/>
        <WebDevelopmentServices/>
        <WhatWeOffer/>
        {/* <RelatedCaseStudies/> */}
        <ProjectShowcase/>
        <CallToAction/>
        <Footer/>
    </>
  )
}

export default Service